import { Form, message } from "antd";
import BaseModalForm from "components/BaseModalForm";
// import ModalUtil from "utils/modalUtil";
import { MODAL_SIZE_MEDIUM } from "constants/Layout";
import _, { omit } from "lodash";
import React, { ForwardedRef, forwardRef, useCallback, useMemo } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, nameRegexValidator } from "utils/formUtils";
import { duplicateNameValidator } from "utils/validatorUtil";

type MandiantAdvantageLoginConfirFormProps = {
  onUpdateConfigComponent: (param: boolean) => void;
  loginConfigList: any;
  config: any;
  afterClose: (data?: any) => void;
};

function MandiantAdvantageLoginConfirForm(
  {
    loginConfigList,
    onUpdateConfigComponent,
    ...props
  }: MandiantAdvantageLoginConfirFormProps,
  ref: ForwardedRef<any>,
) {
  const isEdit = !_.isUndefined(props.config);
  const [form] = Form.useForm();

  const onOk = useCallback(
    async (data) => {
      try {
        let payload = data;
        payload = omit(
          {
            ...payload,
            configType: "MANDIANT_ADVANTAGE",
            config: {
              api_key: payload.api_key,
              api_secret: payload.api_secret,
            },
          },
          ["api_key", "api_secret"],
        );
        await ToolsIntegrationsAPI.postCTILoginDetails(payload).promise;
        message.success(
          `Madiant Advantage Login Configuration created successfully`,
        );
        onUpdateConfigComponent && onUpdateConfigComponent(true);
      } catch (err: any) {
        console.log(err);
      }
    },
    [onUpdateConfigComponent],
  );

  const modalProps = {
    width: MODAL_SIZE_MEDIUM,
  };

  const fields = useMemo(
    () => [
      {
        name: "name",
        label: "Name",
        colSpan: 12,
        required: true,
        props: {
          autoFocus: true,
        },
        rules: [
          duplicateNameValidator({ list: loginConfigList }),
          nameRegexValidator,
        ],
      },
      {
        name: "api_key",
        label: "API Key",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
      {
        name: "api_secret",
        label: "API Secret",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
    ],
    [loginConfigList],
  );

  return (
    <BaseModalForm
      modalProps={modalProps}
      ref={ref}
      afterClose={props.afterClose}
      fields={fields}
      form={form}
      initialValues={props.config}
      onOk={onOk}
      title={
        <> {isEdit ? "Edit" : "Add"} Madiant Advantage Login Credentials </>
      }
    />
  );
}

export default forwardRef(MandiantAdvantageLoginConfirForm);
